/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */
export enum AttributeNames {
  HTTP_STATUS_TEXT = 'http.status_text',
}



// WEBPACK FOOTER //
// ../../../src/enums/AttributeNames.ts